import { State } from '@cemex/cmx-client-layout';
import { createFeatureSelector } from '@ngrx/store';
import * as fromCtdOrder from './ctd-order.reducer';

export const ctdKey = 'ctd';
export const reducers = fromCtdOrder.reducer;

export interface CtdState extends State {
  ctd: fromCtdOrder.CtdOrderState;
}

export const selectCtdState = createFeatureSelector<fromCtdOrder.CtdOrderState>(ctdKey);
